import EntityTableTemplate from "../../MyUI/EntityTableTemplate/EntityTableTemplate";
import { messagesConfig } from "./messages_conf";

export default function Elements() {

  return <EntityTableTemplate config={messagesConfig} />;
}
